import React, { Fragment } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { ListItem, Button } from '@mui/material';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LaunchSharpIcon from '@mui/icons-material/LaunchSharp';
import footerLinksDefault from '../footer/messages/FooterMessages';
import { getIntlLocale } from '../intl/intlSelectors';
import { trackHeaderFooterClick } from '../segment/segmentModule';

export const DrawerFooterLinksDefault = ({
    intl, selectedLocale, trackExternalLinkClickAction
}) => (
    <Fragment>
        <ListItem className='drawer-links'>
            <Button
                className='drawerHeaderButton'
                href='/self_service/v2/about/faq'
                rel='noreferrer noopener'
                target='_blank'
                onClick={() => {
                    trackExternalLinkClickAction('Header Link Click',
                        { title: intl.formatMessage(footerLinksDefault.faq), path: '/self_service/v2/about/faq' });
                }}
            >
                {intl.formatMessage(footerLinksDefault.faq)}
                <LaunchSharpIcon
                    className="manage-gift-card-text-external-link manage-gift-card-text"
                    aria-labelledby={intl.formatMessage(footerLinksDefault.faq)}
                />
            </Button>
        </ListItem>
        <ListItem className='drawer-links'>
            <Button
                className='drawerHeaderButton'
                href='/store/self_service/v2/about/terms_and_conditions'
                rel='noreferrer noopener'
                target='_blank'
                onClick={() => {
                    trackExternalLinkClickAction('Header Link Click',
                        {
                            title: intl.formatMessage(footerLinksDefault.terms),
                            path: '/store/self_service/v2/about/terms_and_conditions'
                        });
                }}
            >
                {intl.formatMessage(footerLinksDefault.terms)}
                <LaunchSharpIcon
                    className="manage-gift-card-text-external-link manage-gift-card-text"
                    aria-labelledby={intl.formatMessage(footerLinksDefault.terms)}
                />
            </Button>
        </ListItem>
        <ListItem className='drawer-links'>
            <Button
                className='drawerHeaderButton'
                href='/store/self_service/v2/about/privacy_policy'
                rel='noreferrer noopener'
                target='_blank'
                onClick={() => {
                    trackExternalLinkClickAction('Header Link Click',
                        {
                            title: intl.formatMessage(footerLinksDefault.privacy),
                            path: '/store/self_service/v2/about/privacy_policy'
                        });
                }}
            >
                {intl.formatMessage(footerLinksDefault.privacy)}
                <LaunchSharpIcon
                    className="manage-gift-card-text-external-link manage-gift-card-text"
                    aria-labelledby={intl.formatMessage(footerLinksDefault.privacy)}
                />
            </Button>

        </ListItem>
        <ListItem className='drawer-links'>
            <Button
                className='drawerHeaderButton'
                href={intl.formatMessage(footerLinksDefault.accessibilityLink)}
                rel='noreferrer noopener'
                target='_blank'
                onClick={() => {
                    trackExternalLinkClickAction('Header Link Click',
                        {
                            title: intl.formatMessage(footerLinksDefault.accessibility),
                            path: intl.formatMessage(footerLinksDefault.accessibilityLink)
                        });
                }}
            >
                {intl.formatMessage(footerLinksDefault.accessibility)}
                <LaunchSharpIcon
                    className="manage-gift-card-text-external-link manage-gift-card-text"
                    aria-labelledby={intl.formatMessage(footerLinksDefault.accessibility)}
                />
            </Button>
        </ListItem>
        <ListItem className='drawer-links'>
            <Button
                className='drawerHeaderButton'
                href={`/self_service/register/?locale=${selectedLocale}`}
                rel='noreferrer noopener'
                target='_blank'
                onClick={() => {
                    trackExternalLinkClickAction('Header Link Click',
                        {
                            title: intl.formatMessage(footerLinksDefault.support),
                            path: `/self_service/register/?locale=${selectedLocale}`
                        });
                }}
            >
                {intl.formatMessage(footerLinksDefault.support)}
                <LaunchSharpIcon
                    className="manage-gift-card-text-external-link manage-gift-card-text"
                    aria-labelledby={intl.formatMessage(footerLinksDefault.support)}
                />
            </Button>
        </ListItem>
    </Fragment>
);

export const mapStateToProps = state => ({
    selectedLocale: getIntlLocale(state)
});

DrawerFooterLinksDefault.propTypes = {
    intl: intlShape.isRequired,
    selectedLocale: PropTypes.string.isRequired,
    trackExternalLinkClickAction: PropTypes.func.isRequired
};

const mapDispatchToProps = {
    trackExternalLinkClickAction: trackHeaderFooterClick
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(DrawerFooterLinksDefault));
